/**
 * Dashboard Redirect Component
 *
 * Redirects /okr/dashboard to /okr with a toast notification.
 * The dashboard has been removed and /okr now shows the Cycles page.
 */

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useToast } from '@/hooks/useToast';

export default function DashboardRedirect() {
  const toast = useToast();

  useEffect(() => {
    toast.info('Dashboard foi removido. Esta é a nova página inicial.');
  }, [toast]);

  return <Navigate to="/okr" replace />;
}
